import React from "react";

import {Container, Grid, ToggleButton, ToggleButtonGroup} from "@mui/material";

export default function UnitToggle({unit,setUnit}){


return(

<Container>
    <Grid container justifyContent="center" sx={{ mb: "10px", mt: "10px" }}>

            <ToggleButtonGroup 
                aria-label="Temperature Unit"
                color="primary"
                value={unit} 
                exclusive 
                onChange={(e,val)=> val && setUnit(val)}>
                <ToggleButton value="C">Celsius</ToggleButton>
                <ToggleButton value="F">Fahrenheit</ToggleButton>
                <ToggleButton value="K">Kelvin</ToggleButton>
            </ToggleButtonGroup>
    </Grid>
</Container>

);

}
